import { createLazyCallbackHook } from '@confluence/loadable/entry-points/lazy-callback.ts';

export const useLazyShowFeedbackFlag = createLazyCallbackHook(
	async () =>
		(await import(/* webpackChunkName: "loadable-showFeedbackFlag" */ './showFeedbackFlag.tsx'))
			.showCreateWithRovoModalCloseFeedbackFlagThunk,
);
